const config = {
  backendUrl: process.env.REACT_APP_BACKEND,
};

export default config;
